/*import/no-extraneous-dependencies*/
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import authSlice from './slices/authSlice';
import menuSlice from './slices/menuSlice';

const reducer = combineReducers({
  auth: authSlice,
  menu: menuSlice
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth']
};

const persistedReducer = persistReducer(persistConfig, reducer);
export const store = configureStore({
  reducer: persistedReducer
});

export const persistor = persistStore(store);
